import { render, staticRenderFns } from "./NextFab.vue?vue&type=template&id=735f2566&scoped=true"
import script from "./NextFab.vue?vue&type=script&lang=js"
export * from "./NextFab.vue?vue&type=script&lang=js"
import style0 from "./NextFab.vue?vue&type=style&index=0&id=735f2566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735f2566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
